import { Box } from '@mui/material'

import { searchBoxStyles as styles } from 'src/components/shared/EnhancedTable/SearchBox/SearchBoxStyles'
import InputSearch from '../../ui/InputSearch'

type Props = {
  searchText: string
  setSearchText: (searchText?: string) => void
  placeholder?: string
}

function GlobalFilter({
  searchText,
  setSearchText,
  placeholder = 'Buscar un elemento'
}: Props): JSX.Element {
  return (
    <Box sx={styles.search}>
      <InputSearch
        id="search-box"
        value={searchText || ''}
        onChange={value => {
          setSearchText(value || undefined) // Set undefined to remove the filter entirely
        }}
        placeholder={placeholder}
      />
    </Box>
  )
}

export default GlobalFilter
